module.exports = __webpack_public_path__ + "static/ghost-of-the-seas-ii-a5662e04572c365951ad2cb24bfd8068.jpg";